// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Counter
     */

    const counters = document.querySelectorAll('.js-counter');
    for (const counter of counters) {

        /**
         * Variables
         */

        let counterHasStarted = false;
        let counterIsVisible = false;
        const counterEnd = parseInt(counter.innerText);
        const counterStart = counter.dataset.counterStart ? parseInt(counter.dataset.counterStart) : 0;
        const counterDuration = counter.dataset.counterDuration ? parseInt(counter.dataset.counterDuration) : 2000;
        const counterSteps = counter.dataset.counterSteps ? parseInt(counter.dataset.counterSteps) : 60;
        counter.innerText = counterStart;

        /**
         * Visible
         */

        const counterVisible = () => {
            const counterPosition = counter.getBoundingClientRect();
            if (
                counterPosition.top >= 0 && counterPosition.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            ) {
                counterIsVisible = true;
            }
        }

        /**
         * Execute counter
         */

        const counterExec = () => {
            if (counterHasStarted == false && counterIsVisible == true) {
                if (counterStart < counterEnd) {
                    incrementCounter();
                } else if (counterStart > counterEnd) {
                    decrementCounter();
                }
                counterHasStarted = true;
            }
        }

        /**
         * Inscrement
         */

        const incrementCounter = () => {
            const counterCurrent = parseInt(counter.innerText);
            const counterIncrement = (counterEnd - counterStart) / counterSteps;
            const counterTimer = setTimeout(incrementCounter, 1 / counterSteps * counterDuration);
            if (counterCurrent < counterEnd) {
                counter.innerText = Math.ceil(counterCurrent + counterIncrement);
            } else {
                counter.innerText = counterEnd;
                clearTimeout(counterTimer);
            }
        }

        /**
         * Decrement
         */

        const decrementCounter = () => {
            const counterCurrent = parseInt(counter.innerText);
            const counterIncrement = (counterStart - counterEnd) / counterSteps;
            const counterTimer = setTimeout(decrementCounter, 1 / counterSteps * counterDuration);
            if (counterCurrent > counterEnd) {
                counter.innerText = Math.max(0, Math.ceil(counterCurrent - counterIncrement));
            } else {
                counter.innerText = counterEnd;
                clearTimeout(counterTimer);
            }
        }

        /**
         * Scroll
         */

        document.addEventListener('scroll', function () {
            counterVisible();
            counterExec();
        });

        counterVisible();
        counterExec();

    }

});
